<template>
    <base-dialog :value="dialog" :width="440" :title="$t('common.change_name')" @input="val => { if (!val) hide() }"
        @close="hide">
        <div class="cn-body">
            <kimsa-text-field dense force-value clearable :placeholder="defaultName" :value="name"
                @change="name = $event" @clear="name = ''" />
            <div v-if="optionNames.length" class="cn-chips">
                <div v-for="(option, i) in optionNames" :key="i" class="cn-chip" @click="name = option.value">
                    {{ option.label }}
                </div>
            </div>
            <div class="cn-hint">{{ $t('routines.empty_name_default_hint', { name: defaultName }) }}</div>
        </div>

        <template v-slot:footer>
            <dialog-actions hide-cancel :confirm-label="$t('common.save')" @confirm="save" />
        </template>
    </base-dialog>
</template>

<script>

import { mapState, mapActions } from 'vuex';
import KimsaTextField from '../../common/inputs/KimsaTextField.vue'
import BaseDialog from "@/components/common/BaseDialog"
import DialogActions from "@/components/common/DialogActions"

export default {
    name: 'ChangeNameDialog',
    components: {
        KimsaTextField,
        BaseDialog,
        DialogActions
    },
    props: {
        defaultNames: {
            type: String,
            default: null
        },
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dialog: false,
            name: '',
            index: null,
            item: null,
        }
    },
    computed: {
        ...mapState(['config']),
        disabled(vm = this) {
            return !vm.name
        },
        optionNames(vm = this) {
            if (!vm.defaultNames) return []
            return (vm.config?.[vm.defaultNames] || []).map(value => ({ value, label: vm.blockNameLabel(value) }))
        },
        defaultName(vm = this) {
            if (vm.index === null || vm.index === undefined) return vm.$t('common.write_here')
            return `${vm.$tc('common.blocks', 1)} ${vm.index + 1}`
        }
    },
    async mounted() {
        const vm = this
        if (!vm.config) await vm.bindConfig()
    },
    methods: {
        ...mapActions(['bindConfig']),
        show(item, index) {
            const vm = this
            vm.name = item?.name || ''
            vm.item = item
            vm.index = index
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.name = ''
            vm.index = null
            vm.item = null
        },
        save() {
            const vm = this
            vm.$emit('save', {index: vm.index, name: vm.name, id: vm.item?.id || null})
            vm.hide()
        },
    },

}

</script>

<style scoped>
.cn-body {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.cn-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.cn-chip {
    padding: 6px 12px;
    border-radius: 8px;
    background: var(--v-surface2-base);
    border: 1px solid var(--v-outline-base);
    font-size: 13px;
    font-weight: 600;
    color: var(--v-txtSecondary-base);
    cursor: pointer;
    transition: all 0.15s;
}

.cn-chip:hover {
    border-color: var(--v-accent-base);
    color: var(--v-accent-base);
}

.cn-hint {
    font-size: 12px;
    color: var(--v-txtMuted-base);
}
</style>